import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuthContext } from "@/context/AuthContext";
import { ProfileInfoCard } from "@/components/settings/ProfileInfoCard";
import { ChangePasswordCard } from "@/components/settings/ChangePasswordCard";

function CompanyInformationCard() {
  const { workspace } = useAuthContext();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Company Information</CardTitle>
        <CardDescription>Your workspace's company name.</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm">{workspace?.name}</p>
      </CardContent>
    </Card>
  );
}

function Settings() {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-2xl">Settings</h1>
      <ProfileInfoCard />
      <CompanyInformationCard />
      <ChangePasswordCard />
    </div>
  );
}

export default Settings;
